<template>

    <v-button class="dropdown-toggle" :size="size" :theme="theme" :disabled="loading">
        <span class="d-flex align-items-center">
            <i v-if="icon" :class="label ? `${icon} mr-5` : icon" />
            <span v-if="prefix" class="text-primary mr-5">{{ prefix }}:</span>
            <span v-if="typeof label === 'string'">{{ label | truncate(30) }}</span>
            <span v-if="typeof label === 'object' && label.value">{{ label.value | truncate(30) }}</span>
            <span v-else-if="typeof label === 'object' && label.icon">
                <i v-for="count in label.icon_repeats ?? 1"
                    :key="`icon-${count}`"
                    :class="label.icon"
                    :style="{ color: label.icon_color }">
                </i>
            </span>
            <v-loader v-if="loading" size="xs" class="ml-5" />
            <i v-else class="fas fa-caret-down ml-5"></i>
        </span>
    </v-button>

</template>

<style scoped lang="scss">

    .dropdown-toggle {
        max-width: 400px;
        &::after {
            display: none;
        }
    }

</style>

<script>

export default {

    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        size: {
            type: String,
            default: 'sm',
        },
        theme: {
            type: String,
            default: 'white',
        },
        label: {
            type: [String, Object],
        },
        icon: {
            type: String,
        },
        prefix: {
            type: String,
        },
    },

}

</script>
